module.exports = __webpack_public_path__ + "img/1516006979.0d485a7c.jpg";